import { autoinject, bindable, customElement } from 'aurelia-framework';
import { AlertService } from '@aurelia-toolkit/alert';
import { ColumnState } from 'ag-grid-community';
import { AgGridAurelia } from '../../ag-grid-aurelia';
import { GridColumnsDialog, IGridColumnsDialogColumn, IGridColumnsDialogModel } from '../dialogs/grid-columns-dialog/grid-columns-dialog';

@autoinject
@customElement('grid-columns-button')
export class GridColumnsButton {
  constructor(private element: Element, private alertService: AlertService) { }

  @bindable
  grid: AgGridAurelia;

  async open() {
    const api = this.grid?.api;
    if (!api) {
      return;
    }
    const currentState = api.getColumnState();
    const columns: IGridColumnsDialogColumn[] = [];
    for (const state of currentState) {
      const column = api.getColumn(state.colId);
      const header = column ? api.getDisplayNameForColumn(column, null) : '';
      if (!header) {
        continue;
      }
      columns.push({ colId: state.colId, header, visible: !state.hide });
    }

    const model: IGridColumnsDialogModel = { columns };
    const action = await this.alertService.open({ viewModel: GridColumnsDialog, model });
    if (action === 'reset') {
      api.resetColumnState();
      this.notifyChanged();
      return;
    }
    if (action !== 'save') {
      return;
    }

    // dialog-managed columns take their new order; columns not shown in the dialog keep their slots
    const managedIds = new Set(model.columns.map(x => x.colId));
    const stateById = new Map(currentState.map(x => [x.colId, x]));
    const managedOrdered = model.columns.map(x => ({
      ...stateById.get(x.colId),
      hide: !x.visible,
      // a manually reordered column no longer belongs to the pinned block
      pinned: x.reordered ? null : stateById.get(x.colId).pinned
    }));
    let managedIndex = 0;
    const newState: ColumnState[] = currentState.map(x => managedIds.has(x.colId) ? managedOrdered[managedIndex++] : x);
    api.applyColumnState({ state: newState, applyOrder: true });
    this.notifyChanged();
  }

  // Lets the hosting view persist the column choice at once instead of on its debounced grid events.
  private notifyChanged() {
    this.element.dispatchEvent(new CustomEvent('grid-columns-changed', { bubbles: true }));
  }
}
